module.exports = __webpack_public_path__ + "img/500_Spear-phishing.48f40b44.png";